/**
 * Open/create the conversation for a partial-sale listing-user by POSTing to the
 * existing `create_chat_from_partial_sale_user` endpoint, which authorizes BOTH
 * sides — the seller messaging an interested buyer, and the buyer messaging the
 * seller (messages_controller#create_chat_from_partial_sale_user).
 *
 * Extracted verbatim from the inline seller→buyer "Message" button so the new
 * buyer→seller "Message Seller" action reuses the exact same authorized path
 * (no new endpoint). The buyer passes their own listing-user `friendly_name`.
 *
 * @param {string} friendlyName - partial_sale_listing_user friendly_name
 */
export const messagePartialSaleUser = (friendlyName) => {
  if (!friendlyName) return;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/messages/create_chat_from_partial_sale_user';

  const friendlyIdInput = document.createElement('input');
  friendlyIdInput.type = 'hidden';
  friendlyIdInput.name = 'friendly_id';
  friendlyIdInput.value = friendlyName;
  form.appendChild(friendlyIdInput);

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'authenticity_token';
  tokenInput.value = (window.ReactOnRails && window.ReactOnRails.authenticityToken()) || '';
  form.appendChild(tokenInput);

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export default messagePartialSaleUser;
